import axios from "_u/axios"

// 佣金列表列表
export const sRewardList = body => {
    return axios.post("api/leader/info/rewardList", body)
}

// 佣金列表明细
export const sRewardView = id => {
    return axios.post("api/leader/info/rewardView", { id })
}

// 佣金列表比例
export const sRewardRateList = () => {
    return axios.post("api/sell/setting/list")
}

// 佣金列表比例设置
export const sRewardRateUpdate = body => {
    return axios.post("api/sell/setting/saveSetting", body)
}

// 佣金列表收益明细
export const sRewardDeatilList = body => {
    return axios.post("api/sell/reward/list", body)
}



// 提现列表列表
export const sExtractList = body => {
    return axios.post("api/sell/extract/list", body)
}

// 提现列表详情
export const sExtractView = id => {
    return axios.post("api/sell/extract/view", { id })
}

// 提现列表确认
export const sExtractConfirm = body => {
    return axios.post("api/sell/extract/confirm", body)
}

// 提现列表结佣
export const sExtractCommission = body => {
    return axios.post("api/sell/extract/commission", body)
}